import { container } from "tsyringe";
import { getCookieShopify } from "../../../application/services/cookieService";
import { LogEvent } from "../../../domain/events/LogEvent";
export class Logger {
    constructor() {
        /**
      * Create message to send to socket
      * @param data Data to send
      * @param event Event to send
      * @returns Message wrapped - socketWrapperMessage
      */
        this.createMessage = (data, event, ip) => {
            data.sessionUserId = getCookieShopify();
            data.ip = ip;
            data.date = new Date();
            data.source = "frontend";
            return {
                event: event,
                data: JSON.stringify(data),
                ip: "",
                isCache: false,
            };
        };
        this.eventBusSocket = container.resolve('IEventBusSocket');
    }
    log(message) {
        var _a;
        const showLogs = (_a = process.env.REACT_APP_SHOW_LOGS) !== null && _a !== void 0 ? _a : 'false';
        var ip = sessionStorage.getItem("ip");
        if (showLogs === 'true') {
        }
        else {
            this.eventBusSocket.send(this.createMessage({ message: message }, LogEvent.REGISTER_LOG, ip !== null && ip !== void 0 ? ip : ""));
        }
    }
}
